export default {
  'mapRightClick': {
    'options': 'Options',
    'addDestinationToRoute': 'Ajouter comme destination',
    'directionsFromHere': 'Itinéraire d\'ici',
    'directionsToHere': 'Itinéraire vers ici',
    'nonStopDirectionsToHere': 'Direct vers ici',
    'addRouteStop': 'Ajouter un arrêt ici',
    'centerHere': 'Centrez ici',
    'addAsIsochroneCenter': 'Ajouter centre de portée',
    'inspectDataOnOSM': 'Voir les données sur OSM'
  }
}
